import { render, staticRenderFns } from "./ServiceProviderTdb.vue?vue&type=template&id=92473b78&"
import script from "./ServiceProviderTdb.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderTdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports